<template>
  <div class="box">
    <!-- <span></span> -->
    <h1>法律声明</h1>
    <div>
      <h3>迈格网络用户隐私保护条款</h3>
      <p>更新时间：2023年01月31日</p>
      <h4>一、引言</h4>
      <p>鼐特（北京）信息技术有限公司（以下称“我们”）注重保护用户的个人信息及个人隐私。本隐私条款解释了用户（以下称“您”）个人信息收集（以下称“信息”）和使用的有关情况，本隐私条款适用于我们向您提供的所有相关软件产品及服务（以下称“产品及服务”）。如果您不同意本隐私条款的任何内容，您应立即停止使用我们的产品及服务。当您使用我们提供的任一产品及服务时，即表示您已同意我们按照本隐私条款来合法使用和保护您的个人信息。</p>
      <p>需要特别说明的是，本政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您说明的隐私权政策。</p>
      <h4>二、我们可能收集的信息</h4>
      <p>我们提供产品及服务时，可能会收集、存储和使用下列与您有关的信息。如果您不提供相关信息，可能无法成为我们的用户或无法享受我们提供的某些产品及服务，或者无法达到相关产品及服务拟达到的效果。我们根据合法、正当、必要的原则，仅收集提供产品及服务所必要的信息。</p>
      <p>我们在您使用产品及服务过程中获得的信息:</p>
      <p>1) 您的浏览器和计算机上的信息。在您访问我们网站或使用我们的产品及服务时，我们系统会自动记录您的浏览器和计算机上的信息（您的IP地址、浏览器类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录）；</p>
      <p>2)获取设备的BOARD, BRAND, CPU_ABI, DEVICE, DISPLAY, HOST, ID, MANUFACTURER, MODEL, PRODUCT, TAGS, TYPE, IDFV，ANDROID_ID, 主要用于计算设备的uuid便于统计设备唯一性，仅限于设备统计。</p>
      <p>3)获取设备的位置信息</p>
      <p>4)查看您的网络链接状态</p>
      <p>您了解并同意，以下信息不适用本隐私条款：</p>
      <p>1) 您在使用我们提供的产品及服务进行搜索时输入的关键字信息；</p>
      <p>2) 违反法律法规规定或违反我们系统规则的行为及我们对您采取的措施；</p>
      <p>3) 应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息及其他可在公开渠道查询到的信息；</p>
      <p>4) 其他您与我们或我们的关联方所签署的协议（包括在线签署的电子协议，例如《迈格网络用户协议》）以及我们系统规则中明确约定或提示您不适用本隐私条款的与您有关的信息。</p>
      <h4>三、您个人信息的分享</h4>
      <p>您的个人信息是我们为您提供产品及服务的重要部分，我们会遵循法律法规对您的信息承担保密义务。除以下情形外，我们不会将您的个人信息披露给第三方：</p>
      <p>1) 征得您的同意或授权；</p>
      <p>2) 根据法律法规的规定或行政、司法机构的要求；</p>
      <p>3) 为履行我们在《迈格网络用户协议》或本隐私条款中的义务或行使我们的权利，向我们的关联方、合作伙伴或代表我们履行某项职能的第三方（例如代表我们发出推送通知的通讯产品及服务商等）分享您的个人信息；如我们与上述第三方分享您的信息，我们将会采用对您的个人敏感信息加密、匿名化处理等手段保障您的信息安全。</p>
      <p>4) 如您是适格的知识产权的投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便于双方处理可能产生的权利纠纷；</p>
      <p>5) 只有共享您的信息，才能提供您需要的产品及服务，或处理您与他人的纠纷或争议；</p>
      <p>6) 您出现违反中国有关法律、法规规定或者违反您与我们签署的相关协议（包括在线签署的电子协议）或违反我们相关系统规则时需要向第三方披露的情形；</p>
      <p>7) 为维护我们及其关联方或我们的其他用户的合法权益。</p>
      <p>随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将在转移前通知您。</p>
      <h4>四、我们如何使用收集的信息</h4>
      <p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</p>
      <p>1. 向您提供服务。</p>
      <p>2. 满足您的个性化需求。</p>
      <p>3. 产品开发和服务优化。例如当我们的软件发生故障时，我们会记录和分析软件故障时产生的日志信息，优化我们的服务；</p>
      <p>若发生个人信息泄露等安全事件，我们会启动应急预案及补救措施，阻止安全事件扩大，并依法履行相关的报告及通知义务。</p>
      <p>4. 安全保障。</p>
      <h4>五、对您个人信息的管理</h4>
      <p>1. 您可以在使用我们产品及服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照本隐私条款与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。</p>
      <p>2. 我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。请通过本政策列明的联系方式与我们联系。</p>
      <p>3. 在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。</p>
      <p>4. 请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</p>
      <h4>六、信息安全</h4>
      <p>1. 我们严格保护您的个人信息安全。我们使用各种制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、篡改、披露或破坏。如果您对我们的个人信息保护有任何疑问，请联系我们的客服。</p>
      <p>2. 在使用我们的产品及服务时，请您妥善保护自己的个人信息，仅在必要情况下向他人提供。如您发现自己的个人信息泄露，尤其是您的账户及密码发生泄漏，请立即联系我们的客服，以便我们采取相应措施。</p>
      <p>3. 个人信息存储地点和期限</p>
      <p>1) 存储信息的地点。</p>
      <p>我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。</p>
      <p>2) 存储信息的期限</p>
      <p>一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
      <p>① 为遵守适用的法律法规等有关规定；</p>
      <p>② 为遵守法院判决、裁定或其他法律程序的规定；</p>
      <p>③ 为遵守相关政府机关或法定授权组织的要求；</p>
      <p>④ 为执行相关产品及服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
      <p>当我们的产品或产品及服务发生停止运营的情形时，我们将采取例如推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</p>
      <h4>七、未成年人的个人信息保护</h4>
      <p>我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们产品及服务前，应事先取得您监护人的书面同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。</p>
      <h4>八、通知和修订</h4>
      <p>为给您提供更好的产品及服务，我们的业务将不时变化，本隐私条款也将随之调整。我们会通过在我们网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问我们产品及服务网站以便及时了解最新的隐私条款。如果您对于本隐私条款或者使用我们产品及服务时对于您的个人信息或隐私情况有任何问题，请联系我们客服并作充分描述，我们将尽力解决。</p>
      <h4>九、联系我们</h4>
      <p>公司名称：鼐特（北京）信息技术有限公司</p>
      <p>联系地址：北京市朝阳区电子城IC/PIC创新中心C1 5层</p>
      <p>个人信息保护相关负责人联系方式：4000-810-510</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>

// 移动端样式
@media only screen and (max-width: 1024px) {
  .box{
    line-height: 1.5;
    padding-top: 2.75rem;
    div{
      padding: 1rem 1rem 2rem;
    }
    h1{
      font-size: 1.5rem;
      text-align: center;
      padding:2.5rem 0;
      border-bottom: 1px solid #EAEAEA;
    }
    h3{
      font-size: 1.5rem;
      padding-bottom: 1rem;
      font-weight: 100;
      margin-top: 0.625rem;
    }
    h4{
      font-size: 1.25rem;
      font-weight: bold;
    }
    p{
      font-size: 1rem;
      margin: 1.5rem 0;
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .box{
    line-height: 1.5;
    padding-top: 64px;
    div{
      max-width: 1580px;
      margin: 0 auto;
      padding: 10px 10px 150px;
    }
    h1{
      font-weight: 300;
      text-align: center;
      font-size: 34px;
      border-bottom: 1px solid #EAEAEA;
      padding:55px 0;
    }
    h3{
      font-size: 32px;
      padding-bottom: 64px;
      font-weight: 100;
      margin-top: 10px;
    }
    h4{
      font-size: 20px;
      font-weight: bold;
    }
    p{
      font-size: 17px;
      margin: 24px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/legalNotice.vue